/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { useState } from 'react'
import IPRegistrationModal from '../../modals/IPRegistrationModal'
import IPBulkUploadModal from '../../modals/IPBulkUploadModal'
import { useIntl } from 'react-intl'

type Props = {
  className?: string
}
const TilesWidget4 = ({ className }: Props) => {
  const intl = useIntl()
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [showBulkUpload, setShowBulkUpload] = useState<boolean>(false);

  return (
    <div className={clsx('card h-150px', className)}>
      <div className='card-body d-flex align-items-center justify-content-between flex-wrap'>
        <div className='me-2'>
          <h2 className='fw-bold text-gray-800 mb-3'>{intl.formatMessage({ id: 'MYIP.MODAL.ADD_IP_TITLE' })}</h2>

          {/* <div className='text-muted fw-semibold fs-6'>
            Whitelist your IP.
          </div> */}
        </div>
        <div>
          <button
            className='btn btn-primary fw-semibold px-10'
            onClick={() => setShowCreateAppModal(true)}
          >
            {intl.formatMessage({ id: 'MYIP.BUTTON.ADD_IP' })}
          </button>
          <button
            className='btn btn-primary fw-semibold ms-2 px-10'
            onClick={() => setShowBulkUpload(true)}
          >
            {intl.formatMessage({ id: 'MYIP.BUTTON.BULK_IP_ADD' })}
          </button>
        </div>
      </div>
      <IPRegistrationModal
        show={showCreateAppModal}
        handleClose={() => setShowCreateAppModal(false)}
      />
      <IPBulkUploadModal
        show={showBulkUpload}
        handleClose={() => setShowBulkUpload(false)}
      />
    </div>
  )
}

export { TilesWidget4 }